import { DetailItem } from '@components/process-details/detail-item';
import { ProcessDetails } from '@components/process-details/process-details';
import type { AccountForChildEligibilityDetails } from '@generated-types';
import { getApplicantParentName, getApproverParentName } from '@utils/child-eligibility-utils';

interface ProcessSummaryProps {
    childEligibility: AccountForChildEligibilityDetails;
}

export const ProcessSummary = ({ childEligibility }: ProcessSummaryProps) => {
    return (
        <ProcessDetails>
            <ProcessDetails.Section>
                <DetailItem.AboutAsk />
                <DetailItem.AccountOwner name={childEligibility.child.name} />
                <DetailItem.Parents
                    applicantName={getApplicantParentName(childEligibility)}
                    approverName={getApproverParentName(childEligibility)}
                />
                <DetailItem.NotifyApproverParentOnPhoneNumber />
            </ProcessDetails.Section>
        </ProcessDetails>
    );
};
